import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=df788f32&scoped=true"
import script from "./addBankCard.vue?vue&type=script&lang=js"
export * from "./addBankCard.vue?vue&type=script&lang=js"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=df788f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df788f32",
  null
  
)

export default component.exports